import { render, staticRenderFns } from "./PosSale.vue?vue&type=template&id=2f22ac86&scoped=true"
import script from "./PosSale.vue?vue&type=script&lang=js"
export * from "./PosSale.vue?vue&type=script&lang=js"
import style0 from "./PosSale.vue?vue&type=style&index=0&id=2f22ac86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f22ac86",
  null
  
)

export default component.exports